import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import stylesModal from "../../../components/UnifiedTaxDeclaration/forms/formTypes/Modal.module.css";
import SelectElement from "../../../shared/form/SelectElement";
import InputElement from "../../../shared/form/InputElement";
import styleListData from "../listData/ListTaxDeclarationData.module.css";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import Moment from "moment";
import { useLocation } from "react-router-dom";
import { get, remove, post } from "../../../adapters/xhr/api";
import { DatePickerFormatedWithLimit } from "../../../shared/form/DatePickerFormated";
import Pagination, {
  PaginationTax,
} from "../../../shared/pagination/Pagination";
import { previewAndDownloadDeclarationFile } from "../../../adapters/apis/UnifiedTaxDeclaration/details";

import disputeInfo from "../../../assets/img/Icon feather-file-text.png";
import receipt2 from "../../../assets/img/receipt2.png";
import Modal from "react-modal";

const Claims = () => {
  Modal.setAppElement("body");

  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [claims, setClaims] = useState([]);
  const [links, setLinks] = useState([]);

  const [status, setStatus] = useState([]);
  const [claimLength, setClaimLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [showModal, setShowModal] = useState(false);
  const [idToBeDeleted, setIdToBeDeleted] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams();
  const [error, setError] = useState(null);

  const initialFilters = {
    // per_page: limit,
    claim_number: "",
    date_from: "",
    date_to: "",
    status: "",
  };

  const [filters, setFilters] = useState({
    // per_page: limit,
    claim_number: "",
    date_from: "",
    date_to: "",
    status: "",
  });

  const [filtersErrors, setFiltersErrors] = useState({
    claim_number: "",
    date_from: "",
    date_to: "",
    status: "",
  });

  const handleFromDateChange = (parentCompenent, compenent, key, value) => {
    // If both date_from and date_to have values, clear date_to
    if (filters.date_from && filters.date_to) {
      setFilters((prev) => ({
        ...prev,
        date_to: "",
      }));
    }

    // Update the date_from field
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      date_to: "",
    }));
  };

  const changeDataFormat = (filters) => {
    const data = {
      // per_page: limit,
      claim_number: filters?.claim_number,
      date_from: filters?.date_from
        ? Moment(filters?.date_from).format("yyyy-MM-DD")
        : "",
      date_to: filters?.date_to
        ? Moment(filters?.date_to).format("yyyy-MM-DD")
        : "",
      status: filters?.status,
    };
    return data;
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit); // Update
    setCurrentPage(1); // Reset to first
    callback(1, newLimit);
  };

  const callback = (active, newLimit) => {
    try {
      setIsLoading(true);
      setCurrentPage(active);
      getClaims(active, changeDataFormat(filters), newLimit || limit, false);
    } catch (error) {
      setError("لا توجد بيانات متاحة");
    }
  };

  const search = () => {
    try {
      // setFlashMessage(false); // Clear the flash message
      setIsLoading(true);
      setCurrentPage(1);
      const formattedFilters = changeDataFormat(filters);
      // Call API with filters
      getClaims(1, formattedFilters, limit, true);
    } catch (error) {
      setError("لا توجد بيانات متاحة");
    }
  };

  const handleClearFilter = () => {
    try {
      setFilters(initialFilters);
      setCurrentPage(1);
      setIsLoading(true);
      getClaims(1, initialFilters);
    } catch (error) {
      setError("لا توجد طلبات متاحة");
    }
  };
  const changeFilters = (parentCompenent, compenent, key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const getFilterStatus = async () => {
    try {
      const response = await get(
        "api/declaration-system/declaration-lookups/claim-status",
      );

      setStatus(response?.data?.data?.status);
    } catch (error) {
      console.log("failed to get status lookup");
    }
  };

  const statusOptions = status?.map((element) => {
    return (
      <option value={element.id} key={element.id}>
        {element?.name}
      </option>
    );
  });

  const getClaims = async (
    pageNum,
    filter,
    newLimit,
    isSearch = false,
    isFirstLoad = false,
  ) => {
    const queryParams = new URLSearchParams();

    queryParams.append("page", pageNum || 1);

    // Only include per_page if not first load
    if (!isFirstLoad) {
      queryParams.append("per_page", newLimit || limit);
    }

    Object?.entries(changeDataFormat(filter))?.forEach(([key, value]) => {
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(typeof value === "string" && value.trim() === "")
      ) {
        queryParams.append(key, value);
      }
    });

    let url;
    if (location?.pathname.includes("payment-under-account")) {
      url = `api/declaration-system/declarations/user/declaration/claims-list/${id}?${queryParams.toString()}`;
    }

    if (location?.pathname.includes("payment-account-debt")) {
      url = `api/declaration-system/declarations/claims-list/under-debt/${id}?${queryParams.toString()}`;
    }

    const response = await get(url);
    if (response?.data?.data?.claims?.data?.length === 0) {
      if (isSearch) {
        setError(" لا توجد بيانات متاحة");
      } else {
        setError(" لا توجد طلبات سداد متاحة");
      }
    }

    setClaims(response?.data?.data?.claims?.data);
    setLinks(response?.data?.data?.claims?.links);
    setClaimLength(response?.data?.data?.claims?.meta?.total);
    setLimit(response?.data?.data?.claims?.meta?.per_page);
    setIsLoading(false);
  };

  useEffect(() => {
    getFilterStatus();
    getClaims(1, changeDataFormat(filters), limit, false, true); // first load → skip per_page
  }, []);

  const cancelClaim = async () => {
    try {
      setIsLoading(true);
      //TODO cancel claim
      if (idToBeDeleted) {
        let url = `api/declaration-system/declarations/user/claim/${idToBeDeleted}`;

        await remove(url, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        });
        getClaims();
        setShowModal(false);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("failed to cancel claim");
    }
  };

  const handlePreviewFile = async (url) => {
    try {
      setIsSubmitting(true);
      const response = await previewAndDownloadDeclarationFile(url);

      const blob = new Blob([response?.data], {
        type: response.headers["content-type"],
      });

      // Create a URL for the blob
      const fileUrl = URL.createObjectURL(blob);
      window.open(fileUrl, "_blank");
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const handlePayment = async (id) => {
    try {
      setIsSubmitting(true);
      const response = await post(
        `api/declaration-system/initial-payment/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      if (response?.data?.is_claim_paid) {
        window.location.href = response?.data?.redirect_url;
      } else {
        initiatePayment(response);
      }
    } catch (error) {
      setIsSubmitting(false);
      console.log("failed to create payment");
    }
  };
  const initiatePayment = (response) => {
    document.initiationForm.action = response?.data?.data?.payment_gateway_url;
    document.getElementById("SenderID").value = response?.data?.data?.SenderID;
    document.getElementById("RandomSecret").value =
      response?.data?.data?.RandomSecret;
    document.getElementById("RequestObject").value =
      response?.data?.data?.RequestObject;
    document.getElementById("HashedRequestObject").value =
      response?.data?.data?.HashedRequestObject;
    document.getElementById("initiationForm").submit();
    window.scrollTo(0, 0);
    // setIsSubmitting(false);
  };

  const data = claims?.map((element, index) => {
    return (
      <tr
        key={element.id}
        title={
          parseInt(element?.status_id) === 5
            ? "سيتم إتاحة عملية السداد مرة أخرى في حال عدم اكتمال السداد الناجح خلال 10 دقائق"
            : ""
        }
      >
        <td data-label="رقم طلب السداد" className="p-3">
          {element?.claim_number || ""}
        </td>
        <td data-label="تاريخ طلب السداد">{element?.claim_date || ""}</td>
        <td data-label="حالة طلب السداد">
          <span
            style={{
              backgroundColor:
                parseInt(element?.status_id) == 1
                  ? "#FFE4C6"
                  : parseInt(element?.status_id) == 2
                    ? "#E6FFE6"
                    : parseInt(element?.status_id) == 3
                      ? "#DBE1F9"
                      : parseInt(element?.status_id) == 4
                        ? "#FFE3E3"
                        : "#CFCFCF",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {element?.status_name || ""}
          </span>
        </td>
        <td data-label="المبلغ">{element?.amount || "0"}</td>
        {[1, 3].includes(parseInt(element?.status_id)) ? (
          <td data-label="الدفع">
            <button
              className="btn btn-primary p-2 px-4"
              onClick={() => handlePayment(element?.id)}
              disabled={isSubmitting}
            >
              الدفع
            </button>
          </td>
        ) : (
          <td data-label="الدفع"></td>
        )}

        {/* {parseInt(element?.status_id) === 1 ? (
          <td data-label="إلغاء طلب السداد">
            <button
              className="btn btn-outline-danger"
              onClick={() => {
                setShowModal(true);
                setIdToBeDeleted(element?.id);
              }}
            >
              إلغاء طلب السداد{" "}
            </button>
          </td>
        ) : (
          <td data-label="إلغاء طلب السداد" className="p-4"></td>
        )} */}

        <td data-label="تفاصيل">
          <button
            onClick={() =>
              handlePreviewFile(
                `/api/declaration-system/declarations/user/claim-details-pdf/${element?.id}`,
              )
            }
            className={
              isSubmitting
                ? styleListData["btn-file-disabled"]
                : styleListData["btn-file"]
            }
            id="dispute_info_icon"
          >
            <i
              className="fa-slab-press fa-regular fa-eye fa-lg px-2"
              style={{ color: "#32A8ED" }}
            ></i>{" "}
            {/* <img src={disputeInfo} className="img-fluid" /> */}
          </button>
        </td>

        {[2, 3].includes(parseInt(element?.status_id)) ? (
          //         &&
          //      !element?.from_wallet
          <td data-label="عمليات الدفع">
            <Link
              to={`/payment-transactions/list/${element?.id}/${id}/${location?.pathname.includes("payment-under-account") ? 1 : 2}`}
              className={styleListData["btn-file"]}
              id="wallet_icon"
            >
              <img src={receipt2} className="img-fluid w-8 h-8" />
            </Link>
          </td>
        ) : (
          <td data-label="عمليات الدفع" className="p-4"></td>
        )}

        {parseInt(element?.status_id) === 2 &&
        parseInt(element?.method_type_id) === 4 ? (
          <td data-label="ايصال السداد">
            <button
              onClick={() =>
                handlePreviewFile(
                  `/api/declaration-system/user/claim-receipt-pdf/${element?.id}`,
                )
              }
              className={styleListData["btn-file"]}
              id="wallet_icon"
            >
              <img src={disputeInfo} className="img-fluid w-8 h-8" />
            </button>
          </td>
        ) : (
          <td data-label="ايصال السداد" className="p-4"></td>
        )}
      </tr>
    );
  });

  return (
    <>
      <form method="POST" id="initiationForm" name="initiationForm" action="">
        <input type="hidden" name="SenderID" id="SenderID" value="" />
        <input type="hidden" name="RandomSecret" id="RandomSecret" value="" />
        <input type="hidden" name="RequestObject" id="RequestObject" value="" />
        <input
          type="hidden"
          name="HashedRequestObject"
          id="HashedRequestObject"
          value=""
        />
      </form>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5> هل أنت متأكد من إلغاء طلب السداد؟</h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={cancelClaim}
              disabled={isLoading}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowModal(false)}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <section className="mt-5">
          {location?.state?.message && (
            <div className="alert alert-danger mt-2 text-center w-25 mx-auto">
              <h3 className="fs-5">{location?.state?.message} </h3>
            </div>
          )}

          <div>
            <div className="row align-items-center px-md-4">
              <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                <InputElement
                  name="claim_number"
                  mb4="mb-4"
                  labelHtmlFor="claim_number"
                  labelClassName={`${styleListData["form-label"]} form-label`}
                  labelText=" رقم طلب السداد"
                  inputType="text"
                  inputClassName="form-control"
                  inputID="claim_number"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  value={filters.claim_number}
                  onChange={changeFilters}
                  pText={filtersErrors.claim_number}
                  maxLength="255"
                  placeholder=" رقم طلب السداد"
                />
              </div>

              <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                <DatePickerFormatedWithLimit
                  name="date_from"
                  name_datepicker="date_from"
                  mb4="mb-4"
                  labelHtmlFor="date_from"
                  labelClassName={`  ${styleListData["form-label"]} form-label`}
                  labelText="من تاريخ طلب السداد"
                  inputType="datePicker"
                  minDate={Moment("2026").startOf("year")}
                  inputClassName="form-control"
                  inputID="to_ddate_fromate"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={filtersErrors.date_from}
                  value={filters.date_from}
                  placeholderText="من تاريخ طلب السداد"
                  onChange={handleFromDateChange}
                />
              </div>
              <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                <DatePickerFormatedWithLimit
                  name="date_to"
                  name_datepicker="date_to"
                  mb4="mb-4"
                  labelHtmlFor="date_to"
                  labelClassName={`  ${styleListData["form-label"]} form-label`}
                  labelText="إلى تاريخ طلب السداد"
                  inputType="datePicker"
                  inputClassName={`${styleListData["form-control"]} form-control`}
                  inputID="date_to"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={filtersErrors.date_to}
                  value={filters.date_to}
                  valueDate={filters.date_to}
                  onChange={changeFilters}
                  minDate={filters.date_from || Moment("2026").startOf("year")}
                  placeholderText="إلى تاريخ طلب السداد"
                />
              </div>

              <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                <SelectElement
                  mb4="mb-4"
                  labelHtmlFor="status"
                  labelClassName={`  form-label  ${styleListData["form-label"]}`}
                  labelText="حالة طلب السداد"
                  selectClassName={`${styleListData["form-select"]} form-select`}
                  selectID="status"
                  name="status"
                  options={statusOptions}
                  default="حالة طلب السداد"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  value={filters.status}
                  onChange={changeFilters}
                  pText={filtersErrors.status}
                  placeholderText="حالة طلب السداد"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end p-3">
              <button
                className={styleListData["btns-search"]}
                onClick={search}
                id="declaration_search_button"
              >
                بحث
              </button>
              <button
                className={styleListData["btns-clear"]}
                onClick={handleClearFilter}
                id="declaration_clear_button"
              >
                إعادة
              </button>
            </div>
          </div>
          <div
            className={`${styleListData["table-responsive"]} table-responsive`}
          >
            <table className="table">
              <thead>
                <tr>
                  <th scope="col" className="h5 fw-bold">
                    رقم طلب السداد
                  </th>
                  <th scope="col" className="h5 fw-bold">
                    تاريخ طلب السداد
                  </th>

                  <th scope="col" className="h5 fw-bold">
                    حالة طلب السداد
                  </th>
                  <th scope="col" className="h5 fw-bold">
                    المبلغ
                  </th>
                  <th scope="col" className="h5 fw-bold"></th>
                  {/* <th scope="col" className="h5 fw-bold"></th> */}

                  <th scope="col" className="h5 fw-bold">
                    تفاصيل
                  </th>
                  <th scope="col" className="h5 fw-bold">
                    عمليات الدفع
                  </th>

                  <th scope="col" className="h5 fw-bold">
                    ايصال السداد
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data
                ) : (
                  <tr>
                    <td colSpan={12} className="h5 text-center">
                      {error}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <PaginationTax
            limit={limit}
            count={claimLength}
            active={currentPage}
            callback={callback}
            handleLimitChange={handleLimitChange}
            links={links}
            isClaimPagination={true}
          />
        </section>
      )}
    </>
  );
};

export default Claims;
